module.exports = __webpack_public_path__ + "static/img/yytx10.5918e39.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx10.png
// module id = 882
// module chunks = 0